import {Text, View} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import {LessonStatus} from 'stores/ClassStore';
import strings from '../../../translations';
import styleSheet from './styles';

export interface LessonStatusProps {
  status: LessonStatus;
}

const LessonStatuses = (props: LessonStatusProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  let containerStyle = {};
  let textStyle = {};
  let text = '';

  switch (props.status) {
    case LessonStatus.completed:
      (containerStyle = styles.completedContainerStyle),
        (textStyle = styles.completedTextStyle),
        (text = strings.analyticsScreen.completed);
      break;

    case LessonStatus.error:
      (containerStyle = styles.errorContainerStyle),
        (textStyle = styles.errorTextStyle),
        (text = strings.analyticsScreen.error);
      break;

    case LessonStatus.inProgress:
      (containerStyle = styles.inProgressContainerStyle),
        (textStyle = styles.inProgressTextStyle),
        (text = strings.analyticsScreen.inProgress);
      break;

    case LessonStatus.notStarted:
      (containerStyle = styles.notStartedContainerStyle),
        (textStyle = styles.notStartedTextStyle),
        (text = strings.analyticsScreen.notStarted);
      break;

    case LessonStatus.cancelled:
      (containerStyle = styles.cancelledContainerStyle),
        (textStyle = styles.cancelledTextStyle),
        (text = strings.analyticsScreen.cancelled);
      break;
  }

  return (
    <View style={[styles.containerStyle, containerStyle]}>
      <Text style={[styles.textStyle, textStyle]}>{text}</Text>
    </View>
  );
};

export default LessonStatuses;
